/* @flow */
import * as React from 'react';

import ComposableTable from './ComposableTable';

import type { Props as ComposableTableProps } from './ComposableTable';

type Props = ComposableTableProps & { pageHeader: React.Element<any>, pageHeaderHeight: number };

export function ComposableTableWithFixedPageHeader(props: Props) {
  const { pageHeader, pageHeaderHeight, ...tableProps } = props;
  return (
    <div>
      {pageHeader}
      <ComposableTable topOffset={pageHeaderHeight} {...tableProps} />
    </div>
  );
}
